import {View} from './view';
import {Translations} from '../config/translations';

export class MultipleContactsView extends View {

    init() {
        const amountForm = document.createElement('form');
        amountForm.className = 'hs-form stacked guest-form df-f df-f-multiple-contacts';

        const container = this.getHtmlElement('#df-card-container');
        container.appendChild(amountForm);
    }

    addGuestFields(nodes: Node[], index: number) {

        const wrapper = document.createElement('div');
        wrapper.className = 'df-guest-set';
        wrapper.id = 'df-guest-set-' + index;

        nodes.forEach(node => {
            wrapper.appendChild(node);
        });

        this.getHtmlElement('.guest-form').append(wrapper);
    }

}
